<div [class]="'generic-alert generic-alert--' + type()">
  <mat-icon>{{ icon() }}</mat-icon>
  <ng-content></ng-content>
</div>
